import React from 'react';
import { Box, Container, Typography, Divider, List, ListItem } from '@mui/material';
import AppBarComponent from '../newTestPrepDesign/component/AppBar';

function RefundAndCancellationPage() {
  const sectionTitleStyle = {
    fontWeight: 'bold',
    color: '#B22222',
    fontSize: '18px',
    mt: 4,
  };

  return (
    <>
      <Box>
        <AppBarComponent />
      </Box>

      <Container maxWidth="md" sx={{ py: 4, mt: 12 }}>
        <Typography variant="h2" gutterBottom>
          Cancellation and Refund Policy
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          <strong>Last Updated:</strong> 07/01/2025
        </Typography>
        <Typography paragraph>
          This Cancellation and Refund Policy outlines the conditions under which refunds and cancellations are permitted for services purchased through the official STM (SIEC Test Masters) student platform.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography sx={sectionTitleStyle}>1. Applicability</Typography>
        <Typography paragraph>
          This policy applies exclusively to purchases made through our online portal:<br />
          👉 <a href="https://student.siectestmasters.in" target="_blank" rel="noopener noreferrer">https://student.siectestmasters.in</a><br />
          It does not apply to any payments made offline, in cash, or at physical SIEC centers or branches.
        </Typography>

        <Typography sx={sectionTitleStyle}>2. Conditions for Refund Eligibility</Typography>
        <List sx={{ pl: 3, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item' }}>The cancellation request must be made before the first set of study material has been dispatched.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Refund requests must be submitted prior to the first login or before accessing any course content or service.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Once any part of the service is accessed or materials are dispatched (physical or digital), no refund will be granted.</ListItem>
        </List>

        <Typography sx={sectionTitleStyle}>3. How to Request a Refund</Typography>
        <Typography paragraph>
          To initiate a refund request, the student must contact us using either of the following methods:
        </Typography>
        <List sx={{ pl: 3, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item' }}>
            ✉️ <strong>Email Request:</strong> Send a refund request from your registered email ID to: <a href="mailto:cscanada@siecindia.com">cscanada@siecindia.com</a>
          </ListItem>
          <ListItem sx={{ display: 'list-item' }}>
            📝 <strong>Written Request by Post:</strong><br />
            STM (SIEC Test Masters)<br />
            A1/153, Ground Floor,<br />
            Behind Green Fields School,<br />
            Safdarjung Enclave,<br />
            New Delhi – 110 029, India
          </ListItem>
        </List>

        <Typography sx={sectionTitleStyle}>4. Refund Processing Terms</Typography>
        <List sx={{ pl: 3, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item' }}>An administrative fee of Rs. 1,000/- or 10% of the transaction amount (whichever is higher) will be deducted from the refund.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>For credit/debit card payments, the amount will be refunded to the same card/account.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>For cheque or demand draft payments, the refund will be made out to the original payee and sent to the provided address.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>No refunds will be processed for services or content already accessed, used, or delivered.</ListItem>
        </List>

        <Typography sx={sectionTitleStyle}>5. Processing Timeline</Typography>
        <List sx={{ pl: 3, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item' }}>Refunds will be initiated within 5 working days of receiving a valid refund request.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>The refund amount will be credited within 30 working days, depending on the payment method and bank processes.</ListItem>
        </List>

        <Typography sx={sectionTitleStyle}>6. Non-Refundable Situations</Typography>
        <List sx={{ pl: 3, listStyleType: 'disc' }}>
          <ListItem sx={{ display: 'list-item' }}>The student has accessed the portal and/or used any part of the course.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Course materials (hard copy or soft copy) have been dispatched.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Payment was made through offline or third-party means not linked to the student portal.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Special discount codes or promotional packages were used at the time of purchase.</ListItem>
        </List>

        <Typography sx={sectionTitleStyle}>7. Contact Information</Typography>
        <Typography paragraph>
          For any clarification or further assistance, please contact:
        </Typography>
        <Typography>
          📧 Email: <a href="mailto:cscanada@siecindia.com">cscanada@siecindia.com</a><br />
          🌐 Website: <a href="https://siectestmasters.com" target="_blank" rel="noopener noreferrer">https://siectestmasters.com</a>
        </Typography>
      </Container>
    </>
  );
}

export default RefundAndCancellationPage;
